import { LawsuitResponsible } from "@customTypes/user/responsible";

export const FETCH_RESPONSIBLES = "FETCH_RESPONSIBLES";

export const fetchResponsiblesAction =
  (responsibles: LawsuitResponsible) =>
  (dispatch: (arg0: { type: string; payload: LawsuitResponsible }) => void) => {
    dispatch({
      type: FETCH_RESPONSIBLES,
      payload: responsibles,
    });
  };
